import moment from 'moment';

moment.relativeTimeThreshold('h', 0);
moment.relativeTimeThreshold('m', 0);
moment.relativeTimeThreshold('s', 0);


export type FromNowDaysOnlyOptions = {
    todayLabel?: string;
    futurePrefix?: string;
    pastSuffix?: string;
};

export function fromNowDaysOnly(
    date: moment.MomentInput,
    options: FromNowDaysOnlyOptions = {}
): string {
    const {
        todayLabel = 'hari ini',
        futurePrefix = 'dalam',
        pastSuffix = 'yang lalu',
    } = options;

    if (moment().isSame(date, 'day')) {
        return 'today';
    }

    return moment(date).fromNow();
}   